import { AfterContentInit, ChangeDetectorRef, Directive, Input, OnDestroy, Optional, SkipSelf } from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { RowSelectionManagerDirective } from "./manager.directive";

@Directive({
    selector: "[row-selection-select-self]",
})
export class SelectSelfDirective implements OnDestroy, AfterContentInit {
    @Input() public detailId;
    @Input("bulkSelectManager") public managerPropRef: RowSelectionManagerDirective;

    public selectedIds;
    public state$: Subscription;

    constructor(
        @SkipSelf() @Optional() public parentManager: RowSelectionManagerDirective,
        public ngRedux: ImmutableRedux<any>,
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    public toggle() {
        this.manager.dispatchToggleSelect(this.detailId);
    }

    public get toggleState() {
        const ids = this.selectedIds || {};
        return ids[this.detailId] !== undefined ? ids[this.detailId] : false;
    }

    public ngAfterContentInit() {
        this.manager.registerSelectable(this.detailId);
        this.state$ = this.ngRedux.select(this.manager.rootProp, this.manager.stateProp).subscribe((state) => {
            this.selectedIds = state.ids;
            this.changeDetectorRef.markForCheck();
        });
    }

    public ngOnDestroy() {
        this.manager.unregisterSelectable(this.detailId);
        this.state$.unsubscribe();
    }

    public get manager() {
        return this.parentManager || this.managerPropRef;
    }
}
